import type { ShaderModule } from '@use-gpu/shader';

import { makeContext, useContext, useNoContext } from '@use-gpu/live';
import { bindBundle } from '@use-gpu/shader/wgsl';

import { getPassThruColor } from '@use-gpu/wgsl/mask/passthru.wgsl';

import { applyPBRMaterial } from '@use-gpu/wgsl/material/pbr-apply.wgsl';
import { getDefaultPBRMaterial } from '@use-gpu/wgsl/material/pbr-default.wgsl';

import { getLitFragment } from '@use-gpu/wgsl/instance/fragment/lit.wgsl';
import { getMaterialSurface } from '@use-gpu/wgsl/instance/surface/material-surface.wgsl';

// Default PBR shader
export const DEFAULT_MATERIAL_CONTEXT = {
  solid: {
    getFragment: getPassThruColor,
    getSurface: bindBundle(getMaterialSurface, {
      getMaterial: getDefaultPBRMaterial,
    }),
  },
  shaded: {
    getFragment: getPassThruColor,
    getSurface: bindBundle(getMaterialSurface, {
      getMaterial: getDefaultPBRMaterial,
    }),
    getLight: getLitFragment,
    applyMaterial: applyPBRMaterial,
  },
};

export type MaterialContextProps = Record<string, Record<string, ShaderModule | null | undefined>>;

export const MaterialContext = makeContext<MaterialContextProps>(DEFAULT_MATERIAL_CONTEXT, 'MaterialContext');

export const useMaterialContext = () => useContext(MaterialContext);
export const useNoMaterialContext = () => useNoContext(MaterialContext);
